module.exports = {
  width: 83,
  height: 62,
  bytes: 885,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};